import * as React from 'react';

import cn from 'classnames';

import { getConfig } from '@constants';

import { ESubProject } from '@enums';

import { Icon } from '@common/components/Icon';
import { Logo } from '@common/components/Logo';
import { MultilineText } from '@common/components/MultilineText';
import { Stores } from '@common/components/Stores';

import { IconQrCode } from '@icons';

import { ILandingDescriptionProps } from './types';

import * as s from './LandingDescription.scss';

export const LandingDescription = ({
	locales,
	classNames,
}: ILandingDescriptionProps) => {
	const {
		isMobile,
		landing: { hasQrCode },
	} = getConfig();

	return (
		<section className={cn(s.description, classNames?.blockClassName)}>
			<Logo/>

			<div className={s.descriptionText}>
				<MultilineText
					shouldSplitByWord
					text={isMobile ? locales.descriptionMobile : locales.descriptionDesktop}
					wordClassName={s.descriptionWord}
				/>
			</div>

			{!isMobile && hasQrCode && (
				<Icon glyph={IconQrCode} className={s.qrCode}/>
			)}

			<Stores
				className={classNames?.storesClassName}
				from={ESubProject.BOOM}
				isLanding={true}
			/>
		</section>
	);
};
